"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _CobaltIcon = _interopRequireDefault(require("../../components/CobaltIcon"));

var TableSortLabelTheme = function TableSortLabelTheme() {
  return {
    defaultProps: {
      IconComponent: function IconComponent(props) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], (0, _extends2["default"])({
          name: "chevron-up"
        }, props, {
          className: (0, _clsx["default"])(props.className, 'active-icon')
        })), /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], (0, _extends2["default"])({
          name: "reverse"
        }, props, {
          className: (0, _clsx["default"])(props.className, 'inactive-icon')
        })));
      }
    },
    styleOverrides: {
      root: {
        '&:hover': {
          color: 'inherit'
        },
        '&.Mui-active': {
          color: 'inherit',
          '.inactive-icon': {
            opacity: 0,
            display: 'none'
          },
          '.active-icon': {
            opacity: 1,
            display: 'inherit'
          }
        },
        '&.Mui-active .MuiTableSortLabel-icon': {
          color: 'inherit !important'
        }
      },
      icon: {
        fontSize: 16,
        marginLeft: 4,
        display: 'none',
        '&.inactive-icon': {
          display: 'inherit',
          opacity: 1
        }
      }
    }
  };
};

var _default = TableSortLabelTheme;
exports["default"] = _default;